module.exports = __webpack_public_path__ + "img/weixin.5504c9fd.jpg";